import React, { useState } from 'react';
import { Marker, Popup, useMapEvents } from 'react-leaflet';
import { DivIcon } from 'leaflet';
import { useSearchBox, useGeoSearch } from 'react-instantsearch';

export function Agents() {


    const { query, refine: refineQuery } = useSearchBox();
    const { items, refine: refineItems, currentRefinement, clearMapRefinement, } = useGeoSearch();
    const [previousQuery, setPreviousQuery] = useState(query);
    const [skipViewEffect, setSkipViewEffect] = useState(false);

    // When the user moves the map, we clear the query if necessary to only
    // refine on the new boundaries of the map.

    const onViewChange = ({ target }) => {
        setSkipViewEffect(true);
        if (query.length > 0) {
            refineQuery('');
        }
        refineItems({
            northEast: target.getBounds().getNorthEast(),
            southWest: target.getBounds().getSouthWest(),
        });
    };

    const map = useMapEvents({
        zoomend: onViewChange,
        dragend: onViewChange,
    });

    // When the query changes, we remove the boundary refinement if necessary and
    // we center the map on the first result.

    if (query !== previousQuery) {

        if (currentRefinement) {
            clearMapRefinement();
        }
        // `skipViewEffect` allows us to bail out of centering on the first result
        // if the query has been cleared programmatically.
        if (items.length > 0 && !skipViewEffect) {
            map.setView(items[0]._geoloc);
        }
        setSkipViewEffect(false);
        setPreviousQuery(query);
    }

    return (<>
        {items.map((item) => (<Marker key={item.objectID} position={item._geoloc} icon={createMarker(item)}  eventHandlers={{ click: (e) => { map.flyTo(e.latlng, map.getZoom() >= 8 ? map.getZoom() : 8 ),{'animate':true,'duration':0.75}} }}>
          <Popup>
            <div className="p-2 text-base font-body">
                <h5 className="text-lg lg:text-xl font-medium text-brand-blue-900 mb-2 lg:mb-4">{item.company}</h5>
                <div className="flex flex-col space-y-3">
                { item.city && 
                    <div className="flex items-center gap-4">
                        <svg className="w-6 lg:w-8 h-auto" width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group"><rect id="Rectangle" fill="#ECF3F9" fillRule="nonzero" x="0" y="0" width="32" height="32" rx="16"></rect><path d="M16.0003,16.6666 C17.1049,16.6666 18.0003,15.7712 18.0003,14.6666 C18.0003,13.562 17.1049,12.6666 16.0003,12.6666 C14.8958,12.6666 14.0003,13.562 14.0003,14.6666 C14.0003,15.7712 14.8958,16.6666 16.0003,16.6666 Z" id="Path" stroke="#2678AB" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"></path><path d="M16.0003,22.6666 C18.667,19.9999 21.3337,17.6121 21.3337,14.6666 C21.3337,11.7211 18.9458,9.33325 16.0003,9.33325 C13.0548,9.33325 10.667,11.7211 10.667,14.6666 C10.667,17.6121 13.3337,19.9999 16.0003,22.6666 Z" id="Path" stroke="#2678AB" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"></path></g></g></svg>
                        <div className='flex flex-col'>
                            <div>{item.city}, {item.state}</div>
                            { item.website && <a href={item.website}> {item.website} </a> }
                        </div>
                    </div>
                }
                { item.phone && 
                    <div className="flex items-center gap-4">
                        <svg className="w-6 lg:w-8 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="none" fillRule="evenodd"><rect width="32" height="32" fill="#ECF3F9" fillRule="nonzero" rx="16"/><path stroke="#2678AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".75" d="M13.587 13.902a9.735 9.735 0 0 0 1.897 2.674 9.735 9.735 0 0 0 2.674 1.897c.083.04.124.06.177.075a.697.697 0 0 0 .575-.098c.044-.032.082-.07.159-.146.233-.233.35-.35.466-.426a1.333 1.333 0 0 1 1.454 0c.117.076.234.193.467.426l.13.13c.354.354.531.531.627.722.192.378.192.825 0 1.203-.096.19-.273.368-.627.722l-.105.105c-.354.353-.53.53-.77.665-.266.15-.68.257-.986.256-.275-.001-.463-.055-.84-.161a12.691 12.691 0 0 1-5.522-3.25 12.691 12.691 0 0 1-3.249-5.522c-.107-.376-.16-.564-.16-.84a2.242 2.242 0 0 1 .255-.985c.135-.24.312-.417.665-.77l.105-.105c.354-.354.531-.531.722-.627a1.333 1.333 0 0 1 1.203 0c.19.096.368.273.722.627l.13.13c.233.233.35.35.426.467a1.333 1.333 0 0 1 0 1.454c-.077.117-.193.233-.426.466a1.336 1.336 0 0 0-.146.16.697.697 0 0 0-.098.574c.015.053.035.094.075.177Z"/></g></svg>
                        {item.phone.trim()}
                    </div>
                }
                { item.email && 
                    <div className="flex items-center gap-4">
                        <svg className="w-6 lg:w-8 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="none" fillRule="evenodd"><rect width="32" height="32" fill="#ECF3F9" fillRule="nonzero" rx="16"/><path stroke="#2678AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".75" d="m22.333 20-4.429-4m-3.81 0-4.428 4m-.333-7.333 5.443 3.81c.441.309.662.463.901.523.212.052.433.052.645 0 .24-.06.46-.214.901-.523l5.443-3.81m-10.133 8.666h6.933c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.427.218-.988.218-2.108v-4.266c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-6.933c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v4.266c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218Z"/></g></svg>
                        <a
                            className='truncate'
                            href={`mailto:${item.email.trim()}`}
                            onClick={() => {
                                gtag('event', 'service_agent', {
                                    'company_name': `${item.company}`,
                                    'state': `${item.state}`,
                                    'event_type': 'email'
                                });
                            }}>{item.email.trim()}</a>
                    </div>
                }
                </div>
            </div>
          </Popup>
        </Marker>))}
    </>);
}
function createMarker(item) {
    return new DivIcon({
        html: `<svg class="text-brand-blue-300 hover:text-brand-blue-900 fill-current duration-200 hover:scale-105" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.667 33.333"><path fill="currentColor" fill-rule="evenodd" d="M14.932 31.743c-.53.527-1.065 1.056-1.599 1.59-.534-.534-1.068-1.063-1.598-1.59C5.64 25.701 0 20.107 0 13.333 0 5.97 5.97 0 13.333 0c7.364 0 13.334 5.97 13.334 13.333 0 6.774-5.642 12.368-11.735 18.41Zm3.401-18.41a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"/></svg>`,
        className: "",
        iconSize: [20, 25],
        popupAnchor: [0, -16],
    });
}
